<div class="container-fluid">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="helloSignForm">
        <mat-accordion>
          <mat-expansion-panel expanded hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Hello Sign Configuration
              </mat-panel-title>
            </mat-expansion-panel-header>
            
            <div class="flex-wrap d-flex p-0">
              <div class="col-md-4">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>API Key</mat-label>
                    <input 
                      [type]="hideApiKey ? 'password' : 'text'"
                      matInput 
                      autocomplete="off" 
                      formControlName="apiKey"
                      [errorStateMatcher]="matcher">
                    <button 
                      mat-icon-button 
                      matSuffix 
                      (click)="toggleApiKeyVisibility()" 
                      [attr.aria-label]="'Hide API Key'" 
                      [attr.aria-pressed]="hideApiKey"
                      type="button">
                      <mat-icon>{{hideApiKey ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="helloSignForm.get('apiKey').hasError('required')">
                      API Key is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-4">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Client ID</mat-label>
                    <input 
                      type="text" 
                      matInput 
                      autocomplete="off" 
                      formControlName="clientId"
                      [errorStateMatcher]="matcher">
                    <mat-error *ngIf="helloSignForm.get('clientId').hasError('required')">
                      Client ID is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="d-flex col-md-12 p-0 justify-content-end">
              <button 
                color="primary" 
                class="outlined-btn" 
                mat-raised-button 
                (click)="resetForm()" 
                type="reset"
                [disabled]="isLoading">
                Reset
              </button>
              <button 
                mat-raised-button 
                color="accent" 
                class="ml-3" 
                (click)="onSubmit()"
                [disabled]="!helloSignForm.valid || isLoading || !hasChanges">
                Save Configuration
              </button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </form>
    </mat-card-content>
  </mat-card>
</div>
